import { type FilterTag } from '@procurify/ui'
import * as Factory from 'factory.ts'
import faker from 'faker'

export const FilterTagMock = Factory.Sync.makeFactory<FilterTag>({
  key: Factory.each(() => faker.commerce.department().toLowerCase()),
  value: Factory.each(() => faker.random.number()),
  label: Factory.each(
    () => faker.commerce.department() + faker.random.words(2)
  ),
})
